import { HttpStatusCodes } from '@service-initiation/shared-clients-http';
import { logger } from '@service-initiation/shared-clients-osp-logger';
import {
  type CreatePaymentIntentRequest,
  ServiceTypeCode,
} from '@service-initiation/shared-clients-tech-care-services';
import { queryClient } from '@service-initiation/shared-utils-query-client';

import { techCareServicesClient } from './clients/techCareServicesClient';
import {
  type CreatePaymentIntentPayload,
  type CreatePaymentIntentResult,
} from './types';

export const createPaymentIntent = async ({
  addressLineOne,
  addressLineTwo,
  bookingWindowId,
  city,
  device_type_option_ids,
  deviceRepairId,
  deviceTypeId,
  email,
  name,
  phone,
  postalCode,
  state,
}: CreatePaymentIntentPayload): Promise<CreatePaymentIntentResult> => {
  const request: CreatePaymentIntentRequest = {
    amount: true,
    aqlead_type_id: 5,
    booking_window_id: bookingWindowId,
    country_code: 'us',
    customer: {
      address_line_1: addressLineOne,
      address_line_2: addressLineTwo,
      can_call: true,
      can_email: true,
      can_sms: false,
      city,
      country: 'US',
      email,
      family_name: name,
      given_name: name,
      phone,
      postal_code: postalCode,
      state,
    },
    customer_message: '',
    device_repair_id: deviceRepairId,
    device_type_id: deviceTypeId,
    is_appointment: false,
    locale: 'us_en',
    partner_data: {
      device_repair_id: deviceRepairId,
      device_type_option_ids,
    },
    referer: 'my.asurion.com/tech-care/repairs',
    service_options: {
      location_type: 'home',
      service_type_code: ServiceTypeCode.REMOTE_TECH,
    },
  };

  try {
    const createPaymentIntentResponse = await queryClient.fetchQuery({
      queryFn: async () => {
        const response = await techCareServicesClient.createPaymentIntent(
          request
        );

        if (response.status === HttpStatusCodes.InternalServerError) {
          const internalErrorMessage =
            'Internal Server error occurred while trying to cancel an appointment.';
          const err = new Error(internalErrorMessage);
          logger.error(err, {
            data: {
              response,
            },
          });
          throw err;
        }

        return response.body.data;
      },
      queryKey: ['createPaymentIntent', request],
      retry: 2,
      staleTime: Infinity,
    });

    return createPaymentIntentResponse;
  } catch (e) {
    const err = e as Error;
    err.message = 'Error occurred while trying to cancel appointment lead.';
    logger.error(err, {
      data: { request },
    });
    throw err;
  }
};
